// extracted by mini-css-extract-plugin
export default {"label_left":"DualButton_label_left__JuyFk","label_right":"DualButton_label_right__fWDcc","fadeInOut":"DualButton_fadeInOut__UYQDK"};